import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, ArrowRight, Mail } from 'lucide-react';
import PillarLayout from './pillar/PillarLayout';

const BASE_URL = 'https://enbet-consulting.de';

export default function CheckoutCancelled() {
  return (
    <PillarLayout
      title="Buchung abgebrochen | ENBET Consulting"
      description="Die Buchung wurde abgebrochen — du kannst sie jederzeit erneut starten."
      canonical={`${BASE_URL}/checkout/cancelled`}
    >
      <section className="bg-white pt-32 pb-20 md:pt-40 md:pb-28 min-h-[60vh]">
        <div className="max-w-[720px] mx-auto px-6 md:px-10 text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <XCircle size={48} className="text-[#1f1f1f]/40 mx-auto mb-6" />
            <p className="text-[#1f1f1f]/50 text-xs uppercase tracking-[0.3em] mb-3 font-bold" style={{ fontFamily: "'Oswald', sans-serif" }}>
              Bezahlung abgebrochen
            </p>
            <h1 className="text-[#1f1f1f] text-3xl md:text-5xl font-bold uppercase tracking-tight leading-tight mb-5" style={{ fontFamily: "'Oswald', sans-serif" }}>
              Kein Problem — nichts wurde abgebucht.
            </h1>
            <p className="text-[#1f1f1f]/70 text-base md:text-lg leading-relaxed mb-10 max-w-xl mx-auto" style={{ fontFamily: "'Manrope', sans-serif" }}>
              Du hast den Bezahlvorgang abgebrochen. Es wurde nichts berechnet.
              Wenn du Fragen zum Produkt oder zur Bezahlung hast, melde dich gerne direkt bei Sebastian — oder buche stattdessen einen kostenlosen 20-Minuten Potenzial-Check.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/#booking" className="inline-flex items-center justify-center gap-2 bg-[#befa0a] text-[#0a0a0a] px-6 py-3 text-xs uppercase tracking-wider font-bold hover:bg-white hover:border hover:border-[#befa0a] transition-colors" style={{ fontFamily: "'Oswald', sans-serif" }}>
                Kostenloses Erstgespräch <ArrowRight size={14} />
              </Link>
              <a href="mailto:info@enbet-consulting.de" className="inline-flex items-center justify-center gap-2 border border-[#1f1f1f]/30 text-[#1f1f1f] px-6 py-3 text-xs uppercase tracking-wider font-bold hover:bg-[#1f1f1f] hover:text-white transition-colors" style={{ fontFamily: "'Oswald', sans-serif" }}>
                <Mail size={14} /> Frage stellen
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </PillarLayout>
  );
}
